NtechApp.FullscreenGrid = function($grid) {
    var me = this;

    me._$grid = $grid;

    me._gridName = null;
    me._$gridsToSubstract = [];

    this._lastResizeDocumentHeight = null;
    this._disableOnBreakpoint = null;

    me._getGridData();

    me._lastResizeDocumentHeight = $(document).height();
    me._updateGridHeight();

    var updateTimeout = null;
    $(window).on(NtechApp.FullscreenGrid.EVENT_WINDOW_RESIZE, function() {
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(function() {
            me._lastResizeDocumentHeight = $(document).height();
            me._updateGridHeight();
        }, 100);
    });

    return this;
};

NtechApp.FullscreenGrid.EVENT_WINDOW_RESIZE = "resize.NtechApp.FullscreenGrid.EventWindowResize";

NtechApp.proto(NtechApp.FullscreenGrid, {
    _getGridData: function() {
        var dataAttr = this._$grid.attr("data-fullscreenGrid");
        var parts = dataAttr.split("|");
        var gridsToSubstractIds = parts[1].split(",");

        for(var i = 0; i < gridsToSubstractIds.length; i++) {
            this._$gridsToSubstract.push($("body").find("#" + gridsToSubstractIds[i]));
        }

        this._gridName = parts[0];

        if(NtechApp.dom.hasAttribute(this._$grid.get(0), "data-disableFullscreenGridOnBp"))
            this._disableOnBreakpoint = this._$grid.attr("data-disableFullscreenGridOnBp");
        else
            this._disableOnBreakpoint = false;
    },

    _updateGridHeight: function() {
        if(this._disableOnBreakpoint !== false) {
            if(NtechApp[this._disableOnBreakpoint]()) {
                this._restoreOriginalHeights();
                return;
            }
        }

        var heightToSubstract = 0;
        $.each(this._$gridsToSubstract, function() {
            heightToSubstract += $(this).outerHeight();
        });

        var footerExtraSpace = 5;
        heightToSubstract += footerExtraSpace;

        var $gridView = this._$grid;
        var gridViewStyles = NtechApp.sizesResolver.getComputedCss($gridView.get(0));
        var gridViewPaddingHeight = parseFloat(gridViewStyles.paddingTop);
        gridViewPaddingHeight += parseFloat(gridViewStyles.paddingBottom);

        //heightToSubstract += gridViewPaddingHeight;

        // No need here to use 'this._lastResizeDocumentHeight' - it was usefull
        // in map.(Because map height can change on filters scroll)
        //if($(document).scrollTop() == 0)
        //    var newGridHeight = $(window).height() - heightToSubstract + "px";
        //else
        //    var newGridHeight = this._lastResizeDocumentHeight - heightToSubstract + "px";
        var newGridHeight = $(window).height() - heightToSubstract + "px";

        this._$grid.css("height", newGridHeight);
        this._$grid.find("[data-fullscreenChild]").css(
            "height", parseFloat(newGridHeight) - gridViewPaddingHeight + "px"
        );
    },

    _restoreOriginalHeights: function() {
        this._$grid.css("height", "auto");
        this._$grid.find("[data-fullscreenChild]").css("height", "auto");
    }
});